import React from 'react';
import { Button, Checkbox } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import FormVentaSello from '../../formularios/FormVentaSello';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;

class FormAcreditacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      existeVenta: false,
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    // eslint-disable-next-line no-unused-vars
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        this.props.onSubmit({
          existeVenta: this.state.existeVenta,
        });
      }
    });
  };

  onFinalizar = (ventaSinStock, detalles, datosPonset, extras) => {
    let datos = {
      existeVenta: this.state.existeVenta,
      detalles,
      datosPonset,
      extras,
    };
    this.props.onSubmit(datos, ventaSinStock);
  };

  onFinalizarMP = (ventaSinStock, detalles, datosMP, extras) => {
    // console.log('ENTRE');
    let datos = {
      existeVenta: this.state.existeVenta,
      detalles,
      datosMP,
      extras,
    };
    // console.log('DATOS: ', datos);

    this.props.onSubmit(datos, ventaSinStock);
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  };

  render() {
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Proceso de Venta en Acreditacion</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          {this.props.config.creacion && (
            <FormItem>
              <Checkbox
                style={{ marginLeft: '30%' }}
                onChange={this.onChangeCheckbox}
              >
                Computar Venta
              </Checkbox>
            </FormItem>
          )}

          {this.state.existeVenta && (
            <div>
              <hr />
              <FormVentaSello
                opcionRender={1}
                organismo={this.props.organismo}
                onFinalizar={(detalles, datosPonset, extras) =>
                  this.onFinalizar(false, detalles, datosPonset, extras)
                }
                crearVentaCompleta={(detalles, datosPonset, extras) =>
                  this.onFinalizar(true, detalles, datosPonset, extras)
                }
                crearVentaMercadoPago={(detalles, datosMP, extras) =>
                  this.setState({ loading: true }, () =>
                    this.onFinalizarMP(true, detalles, datosMP, extras)
                  )
                }
                tramite={'ACREDITACIONES'}
              />
              <hr />
            </div>
          )}

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.existeVenta}
            >
              <Icons.SolutionOutlined />
              Exento
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormAcreditacion);
